import React from "react";
import { iconProps } from "../../Helper";

const CreateWorkflowIcon = ({className}:iconProps) => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
      className={className}
        d="M6.00016 11.6668V6.50016H0.833496V5.50016H6.00016V0.333496H7.00016V5.50016H12.1668V6.50016H7.00016V11.6668H6.00016Z"
        fill="white"
      />
    </svg>
  );
};

export default CreateWorkflowIcon;
